<template>
    <v-app id="work">
        <v-navigation-drawer
            disable-resize-watcher
            v-model="drawer"
            app
            dark
            v-if="isLoggedIn && !totem && !routeFullscreen"
            :mini-variant="compactDrawer"
            :width="compactDrawer ? 72 : 280"
            :temporary="$vuetify.breakpoint.smAndDown"
        >
            <v-list-item class="drawer-header" :class="{ 'drawer-mini': compactDrawer }">
                <v-list-item-content v-if="!compactDrawer">
                    <v-list-item-title class="title"> Menù </v-list-item-title>
                    <v-list-item-subtitle>
                        {{ userdata.username }}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="drawer-toggle" :class="{ 'drawer-mini': compactDrawer }">
                    <v-btn
                        v-if="$vuetify.breakpoint.mdAndUp"
                        icon
                        @click.stop="toggleDrawerMini"
                        :title="compactDrawer ? 'Espandi menù' : 'Comprimi menù'"
                        :aria-label="compactDrawer ? 'Espandi menù' : 'Comprimi menù'"
                    >
                        <v-icon>{{
                            compactDrawer ? "mdi-arrow-expand-horizontal" : "mdi-arrow-collapse-horizontal"
                        }}</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>

            <v-list dense nav v-if="isLoggedIn">
                <v-list-item
                    v-for="item in validMenu(workMenu)"
                    :key="item.title"
                    :to="firstRoute(item)"
                    :title="compactDrawer ? item.title : undefined"
                    @click="onDrawerItemClick"
                >
                    <template>
                        <v-list-item-icon class="drawer-item-icon" :class="{ 'drawer-mini': compactDrawer }">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content v-if="!compactDrawer">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-list-item>
            </v-list>

            <v-row
                class="caption"
                :class="{ 'drawer-mini-version': compactDrawer }"
                style="position: absolute; bottom: 20px; right: 20px"
            >
                <span v-if="compactDrawer" class="drawer-mini-version-text">{{ $AppVersion }}</span>
                <span v-else>Ver. {{ $AppVersion }}</span>
            </v-row>
        </v-navigation-drawer>
        <v-card v-if="!totem && !routeFullscreen">
            <!-- MENU PRINCIPALE -->
            <v-app-bar app dense color="primary" class="work-toolbar" elevate-on-scroll>
                <v-app-bar-nav-icon
                    @click="drawer = !drawer"
                    aria-label="Apri il menù principale"
                    title="Menù principale"
                ></v-app-bar-nav-icon>
                <router-link to="/" class="d-none d-md-block">
                    <v-img
                        v-if="$vuetify.theme.dark"
                        alt="Mecom Logo"
                        contain
                        src="@/assets/logo.png"
                        transition="scale-transition"
                        height="40"
                        width="200"
                    />
                    <v-img
                        v-else
                        alt="Mecom Logo"
                        contain
                        src="@/assets/logo_light.png"
                        transition="scale-transition"
                        height="40"
                        width="200"
                    />
                </router-link>
                <v-toolbar-title class="overflow-hidden">
                    <v-row dense no-gutters align="center">
                        <v-icon class="mr-1 d-none d-md-block">{{ areaIcon }}</v-icon>
                        {{ areaTitle }}
                    </v-row>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <search-box
                    ref="searchCb"
                    class="d-none d-md-flex"
                    v-if="isLoggedIn && $router.currentRoute.name !== 'Search' && canSearch"
                ></search-box>
                <v-btn
                    class="mr-3"
                    icon
                    v-if="isLoggedIn && $router.currentRoute.name !== 'Search' && canSearch"
                    small
                    to="/search"
                    aria-label="Apri la ricerca"
                    title="Ricerca"
                >
                    <v-icon>mdi-text-box-search-outline</v-icon>
                </v-btn>
                <div class="display-1 pr-5 d-none d-sm-none">{{ clock }}</div>
                <diagnostics-badge />
                <!-- THEME SWITCHAROO -->
                <v-btn icon @click="switchTheme()" aria-label="Cambia tema" title="Cambia tema">
                    <v-icon>mdi-theme-light-dark</v-icon>
                </v-btn>
                <!-- POPUP PROBLEMA -->
                <v-btn
                    icon
                    color="orange"
                    v-on:click.stop="openProblemaDialog()"
                    v-if="isLoggedIn"
                    :disabled="problema_dialog !== false || problema.working || problema.opening"
                    data-html2canvas-ignore="true"
                    aria-label="Segnala un problema"
                    title="Segnala un problema"
                >
                    <v-icon>mdi-lifebuoy</v-icon>
                    <v-progress-circular
                        v-if="problema.working !== false || problema.opening"
                        class="ml-1"
                        :size="20"
                        :width="2"
                        color="info"
                        indeterminate
                    ></v-progress-circular>
                </v-btn>
                <v-dialog v-model="problema_dialog" persistent max-width="960">
                    <v-card>
                        <v-card-title class="headline"> Segnala un problema su Work </v-card-title>
                        <v-card-text>
                            <span class="mt-2 mb-2 caption">
                                Utilizza questa finestra per segnalare un problema o un bug con l'interfaccia di Work,
                                riempi i campi e clicca segnala
                            </span>
                            <v-form v-model="form_problema">
                                <v-text-field
                                    label="Operatore:"
                                    v-model="problema.user"
                                    :rules="[(v) => v !== '' || 'Scrivi il tuo nome']"
                                    required
                                ></v-text-field>
                                <v-textarea
                                    placeholder="Descrivi il problema:"
                                    v-model="problema.testo"
                                    :rules="[(v) => v !== '' || 'Campo Richiesto']"
                                    required
                                ></v-textarea>

                                <div class="problema-screenshot-box mt-2">
                                    <div class="d-flex align-center justify-space-between flex-wrap mb-2">
                                        <div>
                                            <div class="subtitle-2">Screenshot pagina</div>
                                            <div class="caption grey--text text--darken-1">
                                                Viene catturato automaticamente e puoi annotarlo prima di inviare.
                                            </div>
                                        </div>
                                        <div class="d-flex align-center flex-wrap">
                                            <v-btn
                                                small
                                                text
                                                color="primary"
                                                class="mr-1"
                                                :loading="problema.screenshot_loading"
                                                @click="captureProblemaScreenshot()"
                                            >
                                                Rigenera
                                            </v-btn>
                                            <v-btn
                                                small
                                                text
                                                color="orange darken-2"
                                                class="mr-1"
                                                :disabled="!problema.screenshot_preview || problema.screenshot_loading"
                                                @click="annotateProblemaScreenshot()"
                                            >
                                                Annota
                                            </v-btn>
                                            <v-btn
                                                small
                                                text
                                                color="grey darken-1"
                                                :disabled="!problema.screenshot_preview || problema.screenshot_loading"
                                                @click="clearProblemaScreenshot()"
                                            >
                                                Rimuovi
                                            </v-btn>
                                        </div>
                                    </div>

                                    <div v-if="problema.screenshot_loading" class="problema-screenshot-loading">
                                        <v-progress-circular indeterminate color="primary" size="28" width="3" />
                                        <span class="ml-2">Sto preparando lo screenshot…</span>
                                    </div>

                                    <v-alert
                                        v-else-if="problema.screenshot_error"
                                        dense
                                        outlined
                                        type="warning"
                                        class="mb-0"
                                    >
                                        {{ problema.screenshot_error }}
                                    </v-alert>

                                    <div v-else-if="problema.screenshot_preview" class="problema-screenshot-preview">
                                        <img
                                            ref="problemaScreenshotPreview"
                                            :src="problema.screenshot_preview"
                                            alt="Screenshot segnalazione"
                                        />
                                    </div>
                                </div>

                                <div v-if="problema.screenshot_annotated" class="mt-3">
                                    <v-alert dense outlined type="info" class="mb-2">
                                        Se hai annotato lo screenshot, descrivi ogni segno qui sotto. Il ticket verrà salvato con un elenco numerato.
                                    </v-alert>

                                    <div
                                        v-for="(annotation, index) in problema.screenshot_annotations"
                                        :key="`annotation-${index}`"
                                        class="d-flex align-start mb-2"
                                    >
                                        <v-textarea
                                            class="flex-grow-1"
                                            :label="`Annotazione ${index + 1}`"
                                            :placeholder="
                                                index === 0
                                                    ? 'Es: Freccia sul bottone Salva: al click non succede nulla'
                                                    : 'Es: Riquadro sulla tabella: il totale è disallineato'
                                            "
                                            v-model="problema.screenshot_annotations[index]"
                                            :rules="[
                                                (v) =>
                                                    !problema.screenshot_annotated ||
                                                    (v && v.trim() !== '') ||
                                                    'Compila la descrizione di questa annotazione',
                                            ]"
                                            auto-grow
                                            rows="2"
                                            required
                                        ></v-textarea>
                                        <v-btn
                                            icon
                                            color="grey darken-1"
                                            class="ml-2 mt-2"
                                            :disabled="problema.screenshot_annotations.length === 1"
                                            @click="removeProblemaAnnotation(index)"
                                        >
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                    </div>

                                    <div class="d-flex align-center justify-space-between flex-wrap mt-1">
                                        <div class="caption grey--text text--darken-1">
                                            Ogni annotazione deve spiegare chiaramente a cosa si riferisce il segno sullo screenshot.
                                        </div>
                                        <v-btn small text color="primary" @click="addProblemaAnnotation()">
                                            Aggiungi annotazione
                                        </v-btn>
                                    </div>
                                </div>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="orange darken-1" @click="problema_dialog = false"> Annulla </v-btn>
                            <v-btn
                                color="green darken-1"
                                :disabled="!form_problema || problema.working"
                                v-on:click="inviaSegnalazione()"
                            >
                                Invia Segnalazione
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <span class="mr-2" v-if="$sentryEnv === 'develop'">{{ bname }}</span>
                <team-status v-if="isLoggedIn && !userdata.sgi_preview && !isPurchaseWorkspace" :key="`team-${userdata.user_id || userdata.username}`" />
                <notification-bell v-if="isLoggedIn" :key="userdata.user_id || userdata.username" />
                <span class="mr-2 d-none d-md-block" v-if="isLoggedIn">{{ userdata.full_name }}</span>
                <v-btn
                    class="d-none d-md-block"
                    icon
                    v-if="isLoggedIn && !userdata.sgi_preview && avatar !== undefined"
                    @click="openAvatarDialog"
                    aria-label="Apri il profilo utente"
                    title="Profilo utente"
                >
                    <v-avatar color="orange" size="40">
                        <img alt="avatarrr" :src="avatar.avatar" />
                    </v-avatar>
                </v-btn>

                <v-btn icon v-on:click="doLogout" v-if="isLoggedIn" aria-label="Esci" title="Esci">
                    <v-icon>mdi-logout</v-icon>
                </v-btn>

                <v-dialog v-model="avatarDialog" max-width="520">
                    <v-card>
                        <v-card-title class="headline">Profilo Utente</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <v-avatar color="orange" size="88">
                                        <img
                                            v-if="userProfile.avatar_url"
                                            alt="avatar-profile"
                                            :src="userProfile.avatar_url"
                                        />
                                    </v-avatar>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="caption grey--text">Nome</div>
                                    <div class="text-body-1">{{ userProfile.first_name || "-" }}</div>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="caption grey--text">Cognome</div>
                                    <div class="text-body-1">{{ userProfile.last_name || "-" }}</div>
                                </v-col>
                                <v-col cols="12" v-if="userProfile.avatar_upload_enabled">
                                    <v-file-input
                                        v-model="newAvatarFile"
                                        accept="image/*"
                                        label="Aggiorna avatar"
                                        prepend-icon="mdi-camera"
                                        dense
                                        :disabled="profileUploadLoading"
                                    ></v-file-input>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="avatarDialog = false">Chiudi</v-btn>
                            <v-btn
                                v-if="userProfile.avatar_upload_enabled"
                                color="primary"
                                :loading="profileUploadLoading"
                                :disabled="!newAvatarFile"
                                @click="uploadAvatar"
                            >
                                Salva Avatar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <template v-slot:extension v-if="subMenu">
                    <v-tabs show-arrows align-with-title optional color="white">
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                        <template v-for="(item, key) in subMenu">
                            <WorkSubmenuGroup v-if="item.children" :key="key" :item="item" />
                            <v-tab
                                v-else
                                :key="key"
                                :to="item.route"
                                :exact="Boolean(item.exact)"
                                :exact-path="Boolean(item.exactPath)"
                                :aria-label="item.ariaLabel || null"
                            >
                                <v-badge
                                    v-if="item.badge"
                                    color="orange"
                                    :content="getBadgeValue(item.route.name)"
                                    :value="getBadgeValue(item.route.name) > 0"
                                    :title="item.badge.tooltip"
                                >
                                    <v-icon v-if="item.icon" class="d-none d-md-block">{{ item.icon }} </v-icon>
                                    {{ item.title }}
                                    <v-chip v-if="item.test" x-small label color="amber darken-2" text-color="black" class="ml-2">
                                        TEST
                                    </v-chip>
                                </v-badge>
                                <div v-else class="d-flex align-center">
                                    <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                                    {{ item.title }}
                                    <v-chip v-if="item.test" x-small label color="amber darken-2" text-color="black" class="ml-2">
                                        TEST
                                    </v-chip>
                                </div>
                            </v-tab>
                            </template>
                    </v-tabs>
                    <v-fab-transition>
                        <v-btn
                            fab
                            small
                            absolute
                            bottom
                            right
                            elevation="3"
                            class="orange mr-2"
                            :title="item.title"
                            v-on:click="fabClick(item.event)"
                            v-for="(item, key) in floating_buttons[$router.currentRoute.name]"
                            v-bind:key="key"
                        >
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-btn>
                    </v-fab-transition>
                </template>
            </v-app-bar>
        </v-card>
        <v-main :class="{ 'route-fullscreen': routeFullscreen }">
            <diagnostics-badge v-if="totem || routeFullscreen" floating />
            <v-alert v-if="impersonation" icon="mdi-account-switch" prominent class="impersonation-banner ma-0" role="status">
                <div class="impersonation-banner__content">
                    <div>
                        <strong>Stai impersonando {{ userdata.full_name || userdata.username }}</strong>
                        <span v-if="userdata.full_name"> ({{ userdata.username }})</span>
                    </div>
                    <v-btn outlined :loading="endingImpersonation" :disabled="endingImpersonation" @click="doLogout">
                        Termina impersonamento
                    </v-btn>
                </div>
            </v-alert>
            <v-alert
                v-if="accessPreviewKey"
                icon="mdi-eye-outline"
                color="blue-grey darken-3"
                dark
                class="access-preview-banner ma-0"
                role="status"
            >
                <div class="access-preview-banner__content">
                    <div>
                        <strong>Anteprima configurazione accessi</strong>
                        <span> · il modulo selezionato viene evidenziato nella pagina reale.</span>
                    </div>
                    <v-btn text small @click="dismissAccessPreview">Chiudi indicazione</v-btn>
                </div>
            </v-alert>
            <v-alert v-if="endingImpersonation" type="info" class="ma-4" role="status" aria-live="polite">
                Uscita dall'impersonamento in corso…
            </v-alert>
            <v-alert v-if="logoutError" type="error" class="ma-4" role="alert">
                <p>{{ logoutError }}</p>
                <v-btn outlined @click="doLogout">Completa uscita</v-btn>
            </v-alert>
            <router-view v-if="!endingImpersonation && !logoutError" @show-pdf="showPdf" />
            <v-overlay z-index="10" :opacity="0.98" v-if="requestpin">
                <v-card fluid>
                    <v-card-title> Autorizzazione Team Leader Richiesta </v-card-title>
                    <v-card-text>
                        <v-form v-model="form_pin">
                            <v-text-field
                                class="bigfield"
                                ref="pin"
                                label="Pin:"
                                hint="Inserisci il tuo pin per abilitare la modifica"
                                type="password"
                                v-model="pin"
                                :rules="[(v) => v !== '' || 'Campo Obbligatorio', rules.pinok, rules.pinok2]"
                                required
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="orange darken-1" to="/"> Annulla </v-btn>
                    </v-card-actions>
                </v-card>
            </v-overlay>
        </v-main>
        <work-pdf-host ref="workPdfHost" />
    </v-app>
</template>

<script>
import DiagnosticsBadge from "./components/diagnostics/DiagnosticsBadge.vue";
import { workMenu } from "./accessMenu";
import WorkSubmenuGroup from "./components/common/WorkSubmenuGroup.vue";

import _ from "lodash";
import SearchBox from "./components/include/SearchBox.vue";
import { bus } from "./main";
import { teamLeaderMixin } from "./mixins/teamleader";
import { centerAvailabilityObserver } from "./mixins/centerAvailability";
import mecomThemeSync from "@/assets/mecom/vue/mecomThemeSync.js";
import NotificationBell from "./components/notifications/NotificationBell.vue";
import TeamStatus from "./components/team-status/TeamStatus.vue";
import WorkPdfHost from "./components/common/pdf/WorkPdfHost.vue";
import { menuAccountAllowed } from "./utils/menuAccountAccess.mjs";
import { ensureCapabilities, menuCapabilityAllowed } from "./utils/accessControl.mjs";

import { clearIdentityCaches } from "./utils/impersonation.mjs";

export default {
    name: "App",
    mixins: [teamLeaderMixin, centerAvailabilityObserver, mecomThemeSync],
    components: {
        WorkSubmenuGroup,
        NotificationBell,
        TeamStatus,
        DiagnosticsBadge,
        SearchBox,
        WorkPdfHost,
    },
    data: () => ({
        clock: "00:00:00",
        drawer: false,
        drawerMini: false,
        clockTimer: undefined,
        badgeTimer: undefined,
        isSearching: false,
        searchModel: null,
        searchSync: null,
        searchTimer: undefined,
        pdfloading: false,
        totem: false,
        searchResponse: {
            hits: {
                hits: [],
            },
        },
        searchFilter: ["art", "odp", "odv"],
        searchDescLimit: 60,
        floating_buttons: {},
        avatar: undefined,
        avatarDialog: false,
        profileUploadLoading: false,
        userProfile: {
            full_name: "",
            first_name: "",
            last_name: "",
            reparto: "-",
            fasi: "",
            avatar_url: "",
            avatar_upload_enabled: false,
        },
        newAvatarFile: null,
        form_problema: undefined,
        problema_dialog: false,
        problema: {
            project: "work",
            subsystem: "Dashboard",
            url: "",
            section: "",
            working: false,
            opening: false,
            testo: "",
            user: "",
            email: "",
            submission_key: "",
            screenshot_loading: false,
            screenshot_error: "",
            screenshot_preview: "",
            screenshot_filename: "",
            screenshot_annotated: false,
            screenshot_annotations: [""],
        },

        badges: {},
        workMenu,
        newBarcode: false,
        barcodeData: undefined,
        lastKeyTime: performance.now(),
        lastKey: undefined,
        endingImpersonation: false,
        logoutError: "",
        accessPreviewKey: "",
        accessPreviewTimers: [],
    }),
    created() {
        // Open sessions keep their release assets; never reload a working form
        // for a version change. See docs/transparent-version-updates.md.
        let app = this;
        window.removeEventListener("keydown", app.barcodeListener);
        window.addEventListener("keydown", app.barcodeListener);

        if (localStorage.darkTheme) {
            this.$vuetify.theme.dark = localStorage.darkTheme === "true";
        } else {
            localStorage.darkTheme = true;
        }

        bus.$on("show-pdf", function (item) {
            console.log("SHOW PDF EVENT", item);
            app.showPdf(item);
        });
        this.clockTimer = setInterval(this.updateClock, 1000);
        this.badgeTimer = setInterval(this.refreshVisibleBadges, this.getBadgeRefreshMs());
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
        window.addEventListener("storage", this.handleIdentityChange);
    },
    async mounted() {
        this.$moment.locale("it");
        if (this.isLoggedIn) {
            try {
                await ensureCapabilities(this.$store, this.$work);
            } catch (error) {
                console.warn("Configurazione accessi non disponibile", error);
            }
        }
        this.totem = this.$route.query?.totem === "true";
        const drawerMiniCache = await this.$vlf.getItem("drawer_mini");
        if (drawerMiniCache !== null && drawerMiniCache !== undefined) {
            if (typeof drawerMiniCache === "string") {
                this.drawerMini = drawerMiniCache === "true";
            } else {
                this.drawerMini = drawerMiniCache === true;
            }
        }
        if (this.drawerMini && this.$vuetify.breakpoint.mdAndUp) {
            this.drawer = true;
        }
        this.$vlf.getItem("config_search").then((value) => {
            if (value) {
                this.searchFilter = value;
            }
        });
        console.info(this.$vuetify.breakpoint.name);
        setTimeout(function () {
            window.scrollTo(0, 1);
        }, 500);
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.barcodeListener);
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
        window.removeEventListener("storage", this.handleIdentityChange);
        clearInterval(this.clockTimer);
        clearInterval(this.badgeTimer);
        this.clearAccessPreviewTimers();
    },
    methods: {
        clearAccessPreviewTimers() {
            this.accessPreviewTimers.forEach((timer) => clearTimeout(timer));
            this.accessPreviewTimers = [];
        },
        findAccessPreviewTarget(key) {
            return Array.from(document.querySelectorAll("[data-access-capability]")).find(
                (element) => element.getAttribute("data-access-capability") === key,
            );
        },
        focusAccessPreview(key) {
            this.clearAccessPreviewTimers();
            document.querySelectorAll(".access-preview-target").forEach((element) => {
                element.classList.remove("access-preview-target");
            });
            this.accessPreviewKey = typeof key === "string" ? key.trim() : "";
            if (!this.accessPreviewKey) return;

            [0, 250, 750, 1500, 2500, 4000].forEach((delay) => {
                const timer = setTimeout(() => {
                    const target = this.findAccessPreviewTarget(this.accessPreviewKey);
                    if (!target) return;
                    target.classList.add("access-preview-target");
                    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
                    target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "center" });
                }, delay);
                this.accessPreviewTimers.push(timer);
            });
        },
        dismissAccessPreview() {
            this.clearAccessPreviewTimers();
            document.querySelectorAll(".access-preview-target").forEach((element) => {
                element.classList.remove("access-preview-target");
            });
            this.accessPreviewKey = "";
            const query = { ...this.$route.query };
            delete query.access_preview;
            this.$router.replace({ path: this.$route.path, query }).catch(() => undefined);
        },
        async openAvatarDialog() {
            this.avatarDialog = true;
            await this.loadUserProfile();
        },
        async loadUserProfile() {
            try {
                const response = await this.$work.get("/user-profile/");
                if (response && response.data) {
                    this.userProfile = {
                        full_name: response.data.full_name || "",
                        first_name: response.data.first_name || "",
                        last_name: response.data.last_name || "",
                        reparto: response.data.reparto || "-",
                        fasi: response.data.fasi || "",
                        avatar_url: response.data.avatar_url || "",
                        avatar_upload_enabled: response.data.avatar_upload_enabled === true,
                    };

                    const mergedUserData = {
                        ...this.userdata,
                        avatar_url: this.userProfile.avatar_url,
                        reparto: this.userProfile.reparto,
                        fasi: this.userProfile.fasi,
                    };
                    this.$store.commit("userdata", mergedUserData);

                    if (this.userProfile.avatar_url) {
                        this.avatar = {
                            avatar: this.userProfile.avatar_url,
                            profile: this.userProfile.avatar_url,
                        };
                    }
                }
            } catch (e) {
                this.$toast.error("Errore caricamento profilo", { icon: "mdi-alert" });
                console.log(e);
            }
        },
        async uploadAvatar() {
            if (!this.newAvatarFile) {
                return;
            }

            if (!this.userProfile.avatar_upload_enabled) {
                this.$toast.info("Avatar non modificabile per questo utente", { icon: "mdi-information" });
                return;
            }

            this.profileUploadLoading = true;
            try {
                const formData = new FormData();
                formData.append("avatar", this.newAvatarFile);

                const response = await this.$work.post("/user-profile/", formData, false, {
                    "Content-Type": "multipart/form-data",
                });

                if (response && response.data && response.data.avatar_url) {
                    this.userProfile.avatar_url = response.data.avatar_url;
                    this.userProfile.reparto = response.data.reparto || this.userProfile.reparto;
                    this.userProfile.fasi = response.data.fasi || this.userProfile.fasi;
                    this.avatar = {
                        avatar: response.data.avatar_url,
                        profile: response.data.avatar_url,
                    };
                    this.$store.commit("userdata", {
                        ...this.userdata,
                        avatar_url: response.data.avatar_url,
                        reparto: this.userProfile.reparto,
                        fasi: this.userProfile.fasi,
                    });
                    this.newAvatarFile = null;
                    this.$toast.success("Avatar aggiornato", { icon: "mdi-check" });
                } else {
                    this.$toast.error("Risposta non valida dal server", { icon: "mdi-alert" });
                }
            } catch (e) {
                const msg = e?.response?.data?.error || "Errore aggiornamento avatar";
                this.$toast.error(msg, { icon: "mdi-alert" });
                console.log(e);
            } finally {
                this.profileUploadLoading = false;
            }
        },
        onDrawerItemClick() {
            if (!this.drawerMini || this.$vuetify.breakpoint.smAndDown) {
                this.drawer = false;
            }
        },
        async toggleDrawerMini() {
            this.drawerMini = !this.drawerMini;
            await this.$vlf.setItem("drawer_mini", this.drawerMini);
        },
        search: _.debounce(function (val) {
            let app = this;
            if (val === undefined || val === null || val.length < 1) {
                app.searchResponse = {
                    hits: {
                        hits: [],
                    },
                };
                return;
            }

            app.isSearching = true;
            this.$work
                .post("search/", {
                    q: val,
                    t_odv: app.searchFilter.indexOf("odv") > -1,
                    t_odp: app.searchFilter.indexOf("odp") > -1,
                    t_art: app.searchFilter.indexOf("art") > -1,
                })
                .then((response) => {
                    if (response !== undefined && app.searchSync !== null) {
                        if (
                            response.data.hits.total === 0 &&
                            (app.searchFilter.indexOf("odv") <= -1 ||
                                app.searchFilter.indexOf("odp") <= -1 ||
                                app.searchFilter.indexOf("art") <= -1)
                        ) {
                            app.searchFilter = ["odv", "odp", "art"];
                        }
                        app.searchResponse = Object.freeze(response.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => (app.isSearching = false));
        }, 500),
        searchEnter: function (event) {
            if (event.keyCode === 13) {
                let query = event.currentTarget.value;
                console.log("Search Enter", query);
                if (query.length > 0) {
                    this.$router.push({
                        name: "Search",
                        params: { query: this.searchSync },
                    });
                }
            }
        },
        isCapslock: function (e) {
            let charCode = e.keyCode;
            let shifton = false;

            if (e.shiftKey) {
                shifton = e.shiftKey;
            } else if (e.modifiers) {
                shifton = !!(e.modifiers & 4);
            }
            if (charCode >= 97 && charCode <= 122 && shifton) {
                return true;
            }
            return charCode >= 65 && charCode <= 90 && !shifton;
        },
        validMenu: function (menu) {
            // menù filtrato
            let app = this;
            return _.filter(menu, function (o) {
                if (
                    o.excludeGroups !== undefined &&
                    _.intersection(app.userdata.groups, o.excludeGroups).length > 0
                ) {
                    return false;
                }
                const capabilityAllowed = menuCapabilityAllowed(o, app.$store);
                if (capabilityAllowed !== undefined) return capabilityAllowed;
                if (app.userdata.admin === true) {
                    return true;
                }
                if (o.groups !== undefined && _.intersection(app.userdata.groups, o.groups).length === 0) {
                    return false;
                }
                return !(o.admin && app.$store.state.user.userdata.admin === false);
            });
        },
        switchTheme: function () {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            localStorage.darkTheme = this.$vuetify.theme.dark;
        },
        onEnter: function () {
            let app = this;
            if (this.searchSync !== undefined && this.searchSync.length >= 3) {
                let q = app.$data.searchSync;
                app.$data.searchEntries = [];
                this.$router
                    .push({
                        name: "Search",
                        params: { query: q },
                    })
                    .then(function () {
                        setTimeout(function () {
                            app.$data.searchResponse.hits.hits = [];
                        }, 50);
                    });
            }
        },
        openProblemaDialog: async function () {
            this.problema.url = this.$router.currentRoute.fullPath;
            this.problema.section = this.$router.currentRoute.name;
            this.problema.opening = true;
            this.problema.screenshot_error = "";

            try {
                await this.captureProblemaScreenshot();
            } finally {
                this.problema.opening = false;
                this.problema_dialog = true;
            }
        },
        captureProblemaScreenshot: async function () {
            this.problema.screenshot_loading = true;
            this.problema.screenshot_error = "";

            const backgroundColor = this.$vuetify.theme.dark ? "#121212" : "#ffffff";
            const screenshotTargets = [
                document.querySelector(".v-main"),
                document.querySelector("#work"),
                document.querySelector(".v-application"),
                document.body,
            ].filter(Boolean);

            const ignoreElements = (element) => {
                if (element?.dataset?.html2canvasIgnore === "true") {
                    return true;
                }

                const tagName = element?.tagName?.toLowerCase?.();
                if (["iframe", "video", "object", "embed"].includes(tagName)) {
                    return true;
                }

                // Se el canvas vien da roba esterna, meio saltarlo che romper tuto.
                if (tagName === "canvas" && element !== this.$refs.problemaScreenshotPreview) {
                    return true;
                }

                return false;
            };

            const buildCloneSanitizer = (aggressive = false) => (clonedDocument) => {
                clonedDocument.querySelectorAll("video, iframe, object, embed").forEach((element) => {
                    element.remove();
                });

                if (!aggressive) {
                    return;
                }

                // Se html2canvas se incastra coi gradienti/canvas dei grafici, li spianemo nel clone.
                clonedDocument.querySelectorAll(".js-plotly-plot, .plotly, canvas, svg").forEach((element) => {
                    if (!element.closest(".problema-screenshot-preview")) {
                        element.remove();
                    }
                });

                clonedDocument.querySelectorAll("*").forEach((element) => {
                    const style = clonedDocument.defaultView?.getComputedStyle?.(element);
                    if (!style) {
                        return;
                    }

                    if (style.backgroundImage && style.backgroundImage.includes("gradient")) {
                        element.style.backgroundImage = "none";
                    }
                });
            };

            const renderScreenshot = async (target, aggressive = false) => {
                const { default: html2canvas } = await import(
                    /* webpackChunkName: "issue-screenshot" */ "html2canvas"
                );
                return await html2canvas(target, {
                    useCORS: true,
                    allowTaint: false,
                    imageTimeout: 1500,
                    logging: false,
                    backgroundColor,
                    scale: Math.min(window.devicePixelRatio || 1, 2),
                    ignoreElements,
                    onclone: buildCloneSanitizer(aggressive),
                });
            };

            let lastError = null;

            try {
                for (const target of screenshotTargets) {
                    try {
                        let canvas;

                        try {
                            canvas = await renderScreenshot(target, false);
                        } catch (error) {
                            const message = String(error?.message || error || "");
                            const isGradientCrash = message.includes("addColorStop") || message.includes("finite floating-point");

                            if (!isGradientCrash) {
                                throw error;
                            }

                            console.warn("Retry screenshot in modalità aggressiva per gradient/chart bug:", target, error);
                            canvas = await renderScreenshot(target, true);
                        }

                        const dataUrl = canvas.toDataURL("image/jpeg", 0.92);
                        this.problema.screenshot_preview = dataUrl;
                        this.problema.screenshot_filename = `work-${(this.problema.section || "pagina").toLowerCase()}-${Date.now()}.jpg`;
                        this.problema.screenshot_annotated = false;
                        this.problema.screenshot_error = "";
                        return;
                    } catch (error) {
                        lastError = error;
                        console.warn("Tentativo screenshot fallito su target:", target, error);
                    }
                }

                throw lastError || new Error("Screenshot capture failed");
            } catch (error) {
                console.error("Errore cattura screenshot segnalazione:", error);
                this.problema.screenshot_error = "Non sono riuscita a catturare lo screenshot automatico.";
            } finally {
                this.problema.screenshot_loading = false;
            }
        },
        annotateProblemaScreenshot: async function () {
            await this.$nextTick();
            const previewTarget = this.$refs.problemaScreenshotPreview;
            if (!previewTarget || !this.problema.screenshot_preview) {
                this.$toast.error("Screenshot non disponibile per l'annotazione.", { icon: "mdi-image-off" });
                return;
            }

            const editorTarget = new Image();
            const viewportWidth = Math.max(window.innerWidth - (this.$vuetify.breakpoint.smAndDown ? 24 : 48), 320);
            const toolbarOffset = 64;

            editorTarget.decoding = "async";
            editorTarget.src = this.problema.screenshot_preview;

            await new Promise((resolve, reject) => {
                editorTarget.onload = resolve;
                editorTarget.onerror = reject;
            });

            const imageRatio = editorTarget.naturalWidth / editorTarget.naturalHeight || 1;
            const editorWidth = viewportWidth;
            const editorHeight = Math.max(Math.round(editorWidth / imageRatio), 240);

            const overlayRoot = document.createElement("div");
            overlayRoot.style.position = "fixed";
            overlayRoot.style.inset = "0";
            overlayRoot.style.zIndex = "2999";
            overlayRoot.style.background = "rgba(0, 0, 0, 0.82)";
            overlayRoot.style.overflow = "auto";
            overlayRoot.style.padding = this.$vuetify.breakpoint.smAndDown ? "8px" : "16px";
            overlayRoot.style.boxSizing = "border-box";

            const editorSurface = document.createElement("div");
            editorSurface.style.position = "relative";
            editorSurface.style.minHeight = "100%";
            editorSurface.style.width = "fit-content";
            editorSurface.style.margin = "0 auto";
            editorSurface.style.paddingTop = `${toolbarOffset}px`;
            editorSurface.style.paddingBottom = "24px";
            overlayRoot.appendChild(editorSurface);

            editorTarget.style.display = "block";
            editorTarget.style.width = `${editorWidth}px`;
            editorTarget.style.height = `${editorHeight}px`;
            editorTarget.style.maxWidth = "none";
            editorTarget.style.maxHeight = "none";
            editorTarget.style.opacity = "1";
            editorTarget.style.pointerEvents = "auto";
            editorSurface.appendChild(editorTarget);
            document.body.appendChild(overlayRoot);

            const { MarkerArea } = await import(
                /* webpackChunkName: "issue-screenshot" */ "markerjs2"
            );
            const markerArea = new MarkerArea(editorTarget);
            markerArea.targetRoot = editorSurface;
            markerArea.settings.displayMode = "inline";
            markerArea.availableMarkerTypes = ["FrameMarker", "FreehandMarker", "ArrowMarker", "HighlightMarker"];
            markerArea.renderAtNaturalSize = true;
            markerArea.renderImageType = "image/jpeg";
            markerArea.renderImageQuality = 0.92;
            markerArea.uiStyleSettings.zIndex = "3000";
            markerArea.uiStyleSettings.toolbarStyleColorsClassName = "problema-marker-toolbar-sticky";

            const cleanupEditorTarget = () => {
                if (overlayRoot.parentNode) {
                    overlayRoot.parentNode.removeChild(overlayRoot);
                }
            };

            markerArea.addEventListener("render", (event) => {
                this.problema.screenshot_preview = event.dataUrl;
                this.problema.screenshot_annotated = true;
                cleanupEditorTarget();
            });
            markerArea.addEventListener("close", () => {
                cleanupEditorTarget();
            });
            markerArea.show();
        },
        clearProblemaScreenshot: function () {
            this.problema.screenshot_preview = "";
            this.problema.screenshot_filename = "";
            this.problema.screenshot_annotated = false;
            this.problema.screenshot_annotations = [""];
            this.problema.screenshot_error = "";
        },
        addProblemaAnnotation: function () {
            this.problema.screenshot_annotations.push("");
        },
        removeProblemaAnnotation: function (index) {
            if (this.problema.screenshot_annotations.length <= 1) {
                this.problema.screenshot_annotations = [""];
                return;
            }

            this.problema.screenshot_annotations.splice(index, 1);
        },
        dataUrlToFile: function (dataUrl, filename) {
            const parts = dataUrl.split(",");
            const match = parts[0].match(/:(.*?);/);
            const mime = match ? match[1] : "image/jpeg";
            const binary = atob(parts[1]);
            const length = binary.length;
            const bytes = new Uint8Array(length);

            for (let i = 0; i < length; i += 1) {
                bytes[i] = binary.charCodeAt(i);
            }

            return new File([bytes], filename, { type: mime });
        },
        inviaSegnalazione: async function () {
            let app = this;

            const cleanedAnnotations = (app.problema.screenshot_annotations || [])
                .map((annotation) => (annotation || "").trim())
                .filter((annotation) => annotation !== "");

            if (app.problema.screenshot_annotated && cleanedAnnotations.length === 0) {
                app.$toast.error("Hai annotato lo screenshot: aggiungi almeno una descrizione guidata.", {
                    icon: "mdi-comment-alert-outline",
                    timeout: 7000,
                });
                return;
            }

            const annotationBlock =
                app.problema.screenshot_annotated && cleanedAnnotations.length > 0
                    ? `\n\n---\nAnnotazioni screenshot:\n${cleanedAnnotations
                          .map((annotation, index) => `${index + 1}. ${annotation}`)
                          .join("\n")}`
                    : "";

            const payload = new FormData();
            if (!app.problema.submission_key) {
                app.problema.submission_key = crypto.randomUUID();
            }
            payload.append("project", app.problema.project);
            payload.append("subsystem", app.problema.subsystem);
            payload.append("url", app.problema.url || "");
            payload.append("section", app.problema.section || "");
            payload.append("testo", `${app.problema.testo || ""}${annotationBlock}`);
            payload.append("user", app.problema.user || "");
            payload.append("email", app.problema.email || "");
            payload.append("submission_key", app.problema.submission_key);

            if (app.problema.screenshot_preview) {
                payload.append(
                    "attachments",
                    app.dataUrlToFile(app.problema.screenshot_preview, app.problema.screenshot_filename || "work-segnalazione.jpg")
                );
            }

            app.problema.working = true;

            this.$work
                .post("/support/tickets/", payload, false, {
                    "Content-Type": "multipart/form-data",
                })
                .then(function (response) {
                    if (response.data !== undefined) {
                        if (response.data.res === "ok") {
                            app.$toast.success(response.data.msg, { icon: "mdi-thumb-up" });
                            app.$vlf.setItem("problema_user", app.problema.user);
                            app.problema.testo = "";
                            app.problema.submission_key = "";
                            app.problema.screenshot_annotations = [""];
                            app.clearProblemaScreenshot();
                        } else {
                            app.$toast.error(response.data.msg, {
                                icon: "mdi-thumb-down",
                                timeout: 10000,
                            });
                        }
                    }
                })
                .finally(() => {
                    app.problema.working = false;
                    app.problema_dialog = false;
                });
        },
        setupFloatingButtins(submenu) {
            // ritorno solo i gruppi che si intersecano
            let app = this;
            if (submenu.floating_buttons !== undefined) {
                let buttons = _.filter(submenu.floating_buttons, function (o) {
                    if (o.groups !== undefined && _.intersection(app.userdata.groups, o.groups).length > 0) {
                        return true;
                    }

                    return !(o.admin && app.$store.state.user.userdata.admin === false);
                });

                app.$set(app.floating_buttons, submenu.route.name, buttons);
            } else {
                app.$set(app.floating_buttons, submenu.route.name, []);
            }
        },
        fabClick: function (event) {
            bus.$emit(event, "blabla");
        },
        firstRoute: function (item) {
            // prima route valida del menu
            try {
                let app = this;
                let routes = _.filter(item.submenu, function (o) {
                    if (!menuAccountAllowed(o, app.userdata)) return false;
                    // ritorno solo i gruppi che si intersecano
                    if (
                        o.excludeGroups !== undefined &&
                        _.intersection(app.userdata.groups, o.excludeGroups).length > 0
                    ) {
                        return false;
                    }
                    const capabilityAllowed = menuCapabilityAllowed(o, app.$store);
                    if (capabilityAllowed !== undefined) return capabilityAllowed;
                    if (o.groups === undefined) {
                        return true;
                    }
                    if (app.userdata.is_superuser) {
                        return true;
                    }
                    return _.intersection(app.userdata.groups, o.groups).length > 0;
                });
                if (routes !== undefined && routes.length > 0) {
                    return routes[0].route;
                } else {
                    return "/";
                }
            } catch (e) {
                return "/";
            }
        },
        showPdf(item) {
            this.drawer = false;
            return this.$refs.workPdfHost.showPdf(item);
        },
        closePdf() { return this.$refs.workPdfHost?.closePdf(); },
        updateClock: async function () {
            if (document.hasFocus()) {
                let now = this.$moment();
                this.$set(this.$data, "clock", now.format("ll") + " " + now.format("LTS"));
                if (this.$data.avatar === undefined && this.isLoggedIn) {
                    this.$data.avatar = await this.$work.getAvatar();
                }
            }
        },
        async doLogout() {
            if (this.impersonation || this.logoutError) {
                if (this.endingImpersonation) return;
                this.endingImpersonation = true;
                this.logoutError = "";
                try {
                    this.$work.logout(this);
                    await this.$nextTick();
                    await clearIdentityCaches(this);
                    window.location.replace("/login");
                } catch (error) {
                    this.logoutError = "L'accesso è terminato, ma non è stato possibile pulire i dati locali. Premi Completa uscita prima di accedere di nuovo.";
                    this.endingImpersonation = false;
                }
                return;
            }
            this.$router.push({ name: "Home" }).then(() => {
                this.$work.logout(this);
            });
        },
        handleIdentityChange(event) {
            if (event.key !== "vuex_user") return;
            try {
                const nextUser = JSON.parse(event.newValue || "null")?.user;
                if ((nextUser?.token || "") !== this.$store.state.user.token) {
                    window.location.reload();
                }
            } catch (error) {
                // A damaged persisted session must not keep another identity visible.
                window.location.reload();
            }
        },
        getBadgeRefreshMs() {
            return this.$sentryEnv == "develop" ? 30000 : 300000;
        },
        getBadgeValue(routeName) {
            if (this.badges?.[routeName]?.identity !== this.$store.getters.token) return 0;
            return this.badges?.[routeName]?.value || 0;
        },
        getBadgeResponseValue(response, responsePath = "conteggio") {
            const value = responsePath.split(".").reduce(
                (current, key) => current?.[key],
                response?.data,
            );
            return value ?? "n/d";
        },
        ensureBadgeState(routeName, forceStale = false) {
            if (!routeName) {
                return;
            }

            if (this.badges[routeName] === undefined || this.badges[routeName].identity !== this.$store.getters.token) {
                this.$set(this.badges, routeName, {
                    timestamp: this.$moment().subtract(1, "day"),
                    value: 0,
                    loading: false,
                    revision: 0,
                    identity: this.$store.getters.token,
                });
                return;
            }

            if (forceStale) {
                this.badges[routeName].revision += 1;
                this.badges[routeName].timestamp = this.$moment().subtract(1, "day");
            }
        },
        getVisibleBadges() {
            return (this.subMenu || []).filter((item) => item.badge && item.route?.name);
        },
        async refreshBadge(submenu, force = false) {
            const routeName = submenu?.route?.name;
            if (!routeName || !submenu?.badge?.url) {
                return;
            }

            this.ensureBadgeState(routeName);
            const badgeState = this.badges[routeName];
            const staleThreshold = this.$moment().subtract(this.getBadgeRefreshMs(), "milliseconds");

            if (badgeState.loading) {
                if (force) badgeState.revision += 1;
                return;
            }

            if (!force && !staleThreshold.isAfter(badgeState.timestamp)) {
                return;
            }

            badgeState.loading = true;
            const revision = badgeState.revision;

            try {
                const response = await this.$work.getsilent(submenu.badge.url);
                if (!response) throw new Error("Conteggio non disponibile");
                if (this.badges[routeName] !== badgeState) return;
                try {
                    badgeState.value = this.getBadgeResponseValue(
                        response,
                        submenu.badge.responsePath,
                    );
                    if (revision === badgeState.revision) badgeState.timestamp = this.$moment();
                } catch (e) {
                    badgeState.value = "n/d";
                }
            } catch (_) {
                badgeState.value = "n/d";
            } finally {
                badgeState.loading = false;
                if (this.badges[routeName] === badgeState && revision !== badgeState.revision && !document.hidden && this.isLoggedIn) {
                    this.refreshBadge(submenu, true);
                }
            }
        },
        refreshVisibleBadges(force = false) {
            if (document.hidden || !this.isLoggedIn || this.$route.meta.publicAuth) {
                return;
            }

            this.getVisibleBadges().forEach((item) => {
                this.refreshBadge(item, force);
            });
        },
        handleVisibilityChange() {
            if (!document.hidden) {
                this.refreshVisibleBadges();
            }
        },
        invalidateBadge(routeName) {
            if (!routeName) {
                return;
            }

            this.ensureBadgeState(routeName, true);
        },
        invalidateBadgesForSocketEvent(message) {
            const route = (message?.route || "").toLowerCase();
            if (!route) {
                return;
            }

            if (["oseon", "oseon_prg", "laser/intaglio-oseon", "intaglio-sort"].includes(route)) {
                ["laser-intaglio-oseon", "laser-intaglio"].forEach((badgeRoute) => {
                    this.invalidateBadge(badgeRoute);
                });
            }

            if (route === "laser/danestare") {
                ["laser-danestare", "laser-sbancalatura", "laser-daubicare"].forEach((badgeRoute) => {
                    this.invalidateBadge(badgeRoute);
                });
            }

            if (route === "fasi") {
                ["ordini-proposte", "laser-proposte"].forEach((badgeRoute) => {
                    this.invalidateBadge(badgeRoute);
                });
            }

            if (route === "offerte") {
                this.invalidateBadge("ordini-offerte");
            }

        },

        barcodeListener(e) {
            if (e.key === "Escape" && (this.$refs.workPdfHost?.pdf.overlay || this.$refs.workPdfHost?.pdf.pending)) {
                e.preventDefault();
                this.closePdf();
                return;
            }
            // Typing or scanning into search belongs to that field, not the global scanner.
            if (e.target?.closest?.('[data-manual-search]')) {
                this.newBarcode = false;
                this.barcodeData = undefined;
                this.lastKey = undefined;
                return;
            }
            //ignoro su pagina di login
            if (this.$route.name === "Login" || this.$route.meta.publicAuth) return;
            if (this.$route.name === "staff-console") return;

            if (this.$route.name === "logs") {
                const activeElement = document.activeElement;
                const isEditableElement =
                    activeElement &&
                    (activeElement.tagName === "INPUT" ||
                        activeElement.tagName === "TEXTAREA" ||
                        activeElement.tagName === "SELECT" ||
                        activeElement.isContentEditable === true);
                const searchBoxElement = this.$refs.searchCb?.$el;
                const isSearchFocused = activeElement && searchBoxElement && searchBoxElement.contains(activeElement);
                if (isEditableElement && !isSearchFocused) {
                    return;
                }
            }

            // ATTENZIONE IL LETTORE BARCODE DEVE ESSERE CONFIGURATO CON LA LINGUA CORRETTA IN BASE ALL'SO
            let app = this;
            let key = e.key;

            if (e.key && (e.key.length === 1 || e.key === "Enter")) {
                if (performance.now() - app.lastKeyTime > 200) {
                    /*
                     * SE TROPPO LENTO RESETTO
                     */
                    console.log(`KEY ${key} time:${Math.round(performance.now() - app.lastKeyTime)}  SLOW`);
                    app.newBarcode = false;
                    app.barcodeData = undefined;
                    app.lastKeyTime = performance.now();
                    app.lastKey = key;
                    return;
                } else {
                    console.log(`KEY ${key} time:${Math.round(performance.now() - app.lastKeyTime)}  OK`);
                    app.lastKeyTime = performance.now();
                }

                // lettura barcode su invio
                if (key === "Enter" && app.newBarcode === true && app.barcodeData !== undefined) {
                    let barcode = app.barcodeData;
                    app.newBarcode = false;
                    app.barcodeData = undefined;

                    const normalizedBarcode = (barcode || "").trim();

                    // Validazione: ignora barcode vuoti o che contengono solo "Enter"
                    if (!normalizedBarcode || /^Enter+$/.test(normalizedBarcode)) {
                        console.warn("Barcode invalido ignorato:", barcode);
                        return;
                    }

                    app.$toast.success("Lettura Barcode " + normalizedBarcode, { icon: "mdi-barcode-scan" });
                    if (app.$refs.searchCb && typeof app.$refs.searchCb.reset === "function") {
                        app.$refs.searchCb.reset();
                    }

                    const odpMatch = normalizedBarcode.toUpperCase().match(/OD[RP]\d+/);
                    if (odpMatch !== null) {
                        const odp = odpMatch[0];
                        if (app.$route.name === "av-operatore") {
                            bus.$emit("scanned-barcode-operatore", odp);
                        } else if (["av-fase", "av-fase-classic", "av-fase-layout-preview"].includes(app.$route.name)) {
                            bus.$emit("scanned-barcode-fase", odp);
                        } else {
                            bus.$emit("scanned-barcode", odp);
                            setTimeout(function () {
                                console.info("BARCODE ROUTE PUSH", odp);
                                app.$router.push({
                                    name: "Ordine",
                                    params: { codice: odp },
                                });
                            }, 200);
                        }
                        return;
                    } else {
                        // un articolo ?
                        setTimeout(function () {
                            console.info("BARCODE ROUTE PUSH", normalizedBarcode);
                            app.$router.push({
                                name: "Articolo",
                                params: { codice: normalizedBarcode },
                            });
                        }, 200);
                    }
                    e.preventDefault();
                } else {
                    // Ignora "Enter" nell'accumulo del barcode
                    if (key === "Enter") {
                        return;
                    }

                    if (app.newBarcode) {
                        app.barcodeData += key;
                    } else {
                        app.newBarcode = true;

                        if (app.lastKey && app.lastKey !== "Enter") {
                            app.barcodeData = app.lastKey;
                            app.barcodeData += key;
                            app.lastKey = undefined;
                        } else {
                            app.barcodeData = key;
                        }
                    }
                }
            }
        },
    },
    watch: {
        '$vuetify.breakpoint.smAndDown'(small) { if (small) this.drawer = false; },
        /*pdf: {
            handler: function (newVal) {
                if (newVal.overlay === false) {
                    this.pdfloading = false
                }
            }, deep: true
        },
        */
        isLoggedIn: function (loggedIn) {
            if (!loggedIn) return;
            ensureCapabilities(this.$store, this.$work).catch((error) => {
                console.warn("Configurazione accessi non disponibile", error);
            });
        },
        $route: {
            immediate: true,
            handler: function (to) {
                this.totem = this.$route.query?.totem === "true";
                document.title = to.meta?.title ? `Work - ${to.meta.title}` : `Work - ${to.name}`;
                this.$nextTick(() => {
                    this.refreshVisibleBadges();
                    this.focusAccessPreview(to.query?.access_preview);
                });
            },
            deep: true,
        },
        requestpin: function (newVal) {
            if (newVal) {
                this.pin = "";
            }
        },
        searchSync: function (val) {
            this.search(val);
        },
        problema_dialog() {
            let app = this;
            if (app.problema.user === "") {
                app.$vlf.getItem("problema_user").then((operatore) => {
                    if (operatore) app.problema.user = operatore;
                });
            }
        },
        searchModel(val) {
            let app = this;
            if (val?._source !== undefined) {
                app.$router
                    .push({
                        name: val._source.route,
                        params: { codice: val._source.codice },
                    })
                    .then(function () {
                        setTimeout(function () {
                            app.$data.searchModel = null;
                            app.$data.searchSync = null;
                            app.$data.searchEntries = [];
                        }, 50);
                    });
            }
        },
        searchFilter: function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$vlf.setItem("config_search", newVal);
            }
            this.search(this.searchSync);
        },
        "$store.state.socketmessage": function (message) {
            this.invalidateBadgesForSocketEvent(message);
        },
    },
    computed: {
        isPurchaseWorkspace() {
            return this.$route.meta.menu === 'acquisti' || [this.$route.path, window.location.pathname].some(path => path === '/acquisti' || path.startsWith('/acquisti/'));
        },
        compactDrawer() { return this.drawerMini && this.$vuetify.breakpoint.mdAndUp; },
        impersonation() {
            return this.isLoggedIn && this.userdata.impersonation?.target === "dashboard";
        },
        routeFullscreen() {
            return Boolean(this.$route.meta.fullscreen || this.$route.meta.publicAuth);
        },
        bname() {
            return this.$vuetify.breakpoint.name;
        },
        requestpin: function () {
            return this.$store.state.requestpin;
        },
        isLoggedIn: function () {
            return this.$store.state.user.isLoggedIn;
        },
        userdata: function () {
            return this.$store.state.user.userdata;
        },
        canSearch: function () {
            // Gli utenti del gruppo Fornitore o Cliente non possono fare ricerche
            if (this.userdata.groups !== undefined) {
                if (this.userdata.groups.indexOf("Fornitore") !== -1) return false;
                return this.userdata.groups.indexOf("Cliente") === -1;
            }
            return false;
        },
        activeMenu: function () {
            const configuredMenu = this.$data.workMenu[this.$route.meta.navigationMenu || this.$route.meta.menu];
            if (configuredMenu) return configuredMenu;
            return _.find(this.$data.workMenu, menu =>
                menu.submenu?.some(item => item.route?.name === this.$route.name)
            ) || null;
        },
        subMenu: function () {
            let app = this;
            if (!this.activeMenu || this.$route.meta.hideSubMenu) return null;
            return _.filter(this.activeMenu.submenu, function (o) {
                if (!menuAccountAllowed(o, app.userdata)) return false;
                if (
                    o.excludeGroups !== undefined &&
                    _.intersection(app.userdata.groups, o.excludeGroups).length > 0
                ) {
                    return false;
                }
                const capabilityAllowed = menuCapabilityAllowed(o, app.$store);
                if (capabilityAllowed !== undefined) return capabilityAllowed;
                if (o.groups === undefined) {
                    if (app.floating_buttons[o.route.name] === undefined) {
                        app.setupFloatingButtins(o);
                    }

                    return true;
                }
                if (app.userdata.admin) {
                    if (app.floating_buttons[o.route.name] === undefined) {
                        app.setupFloatingButtins(o);
                    }

                    return true;
                }

                if (_.intersection(app.userdata.groups, o.groups).length > 0) {
                    if (app.floating_buttons[o.route.name] === undefined) {
                        app.setupFloatingButtins(o);
                    }
                    return true;
                }
            });
        },
        areaTitle: function () {
            return this.activeMenu?.title || this.$route.meta?.title;
        },
        areaIcon: function () {
            return this.activeMenu?.icon || null;
        },
    },
};
</script>

<style>
@import "./assets/work-toolbar.css";
.impersonation-banner {
    position: sticky;
    top: 48px;
    z-index: 10;
    background: #fff3cd !important;
    color: #513c06 !important;
}
.route-fullscreen .impersonation-banner { top: 0; }
.impersonation-banner .v-icon { color: #513c06 !important; }
.impersonation-banner__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    overflow-wrap: anywhere;
}
.impersonation-banner__content .v-btn { color: #513c06 !important; }
.access-preview-banner {
    position: sticky;
    top: 48px;
    z-index: 9;
}
.impersonation-banner + .access-preview-banner { top: 120px; }
.access-preview-banner__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
}
.access-preview-target {
    position: relative;
    z-index: 1;
    border-radius: 4px;
    outline: 4px solid #ffb300 !important;
    outline-offset: 4px;
    animation: access-preview-pulse 1.4s ease-in-out 3;
}
@keyframes access-preview-pulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(255, 179, 0, 0); }
    50% { box-shadow: 0 0 0 10px rgba(255, 179, 0, .28); }
}
@media (prefers-reduced-motion: reduce) {
    .access-preview-target { animation: none; scroll-behavior: auto; }
}
.v-main.route-fullscreen {
    padding: 0 !important;
}

.bgimage {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: url("./assets/pexels-adrien-olichon-2387532.jpg") no-repeat center center;
    filter: brightness(0.2);
    background-size: cover;
    transform: scale(1.1);
}

.bgstripes {
    background-image: linear-gradient(
        45deg,
        #273624 25%,
        #424242 25%,
        #424242 50%,
        #273624 50%,
        #273624 75%,
        #424242 75%,
        #424242 100%
    );
    background-size: 56.57px 56.57px;
    background-repeat: repeat;
}

.drawer-header.drawer-mini {
    justify-content: center;
}

.drawer-toggle.drawer-mini {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-left: 0 !important;
}

.drawer-item-icon.drawer-mini {
    margin-right: 0 !important;
    min-width: 0 !important;
    justify-content: center;
    width: 100%;
}

.drawer-mini-version {
    right: 0 !important;
    left: 0 !important;
    justify-content: center;
}

.drawer-mini-version-text {
    font-size: 10px;
    line-height: 1;
}

.mc-pdf-toolbar.v-system-bar { min-height:var(--touch-target); background:var(--surface) !important; color:var(--ink) !important; }
.mc-pdf-close.v-btn { min-width:var(--touch-target); min-height:var(--touch-target); color:var(--ink) !important; border:1px solid var(--border-control); }
.mc-pdf-close:focus-visible { outline:2px solid var(--focus); outline-offset:2px; }

.problema-screenshot-box {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 12px;
}

.problema-screenshot-loading {
    display: flex;
    align-items: center;
    min-height: 72px;
}

.problema-screenshot-preview {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    overflow: hidden;
    background: #fafafa;
}

.problema-screenshot-preview img {
    display: block;
    width: 100%;
    max-height: 360px;
    object-fit: contain;
}

.problema-marker-toolbar-sticky {
    position: sticky !important;
    top: 0 !important;
    z-index: 3002 !important;
}
</style>
